var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"steps nav nav-justified"},_vm._l((_vm.options),function(step,index){return _c('li',{key:index,class:("steps__item " + (_vm.active === index + 1 ? 'active' : ''))},[_c('span',[_vm._v(_vm._s(step))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d8ced8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Steps/steps.vue
// module id = null
// module chunks = 